import React from 'react';

export default function BrandLogo({ className = '', alt = 'Le Céladon' }) {
  return <img src="/branding/le-celadon-mark.svg" className={className} alt={alt} />;
}
